"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.specification = exports.hdSpecification = void 0;
exports.hdSpecification = {
    mfr_model_num: {
        name: 'Manufacturer Model Number'
    },
    class: {
        name: 'Class'
    },
    chassis_type: {
        name: 'Chassis Type'
    },
    oem_body_style: {
        name: 'OEM Body Style'
    },
    wheelbase_range: {
        name: 'Wheelbase Range', unit: 'in.'
    },
    rear_axle: {
        name: 'Rear Axle'
    },
    gvw_range: {
        name: 'GVW Range', unit: 'lbs'
    },
    brake_system: {
        name: 'Brake System'
    },
    restraint_type: {
        name: 'Restraint Type'
    }
};
exports.specification = {
    Seating: {
        seating_rows: {
            name: 'Seating Rows'
        },
        std_seating: {
            name: 'Standard Seating'
        },
        max_seating: {
            name: 'Max Seating'
        },
        head_room_front: {
            name: 'Head Room (front)', unit: 'in.'
        },
        head_room_rear: {
            name: 'Head Room (rear)', unit: 'in.'
        },
        hip_room_front: {
            name: 'Hip Room (front)', unit: 'in.'
        },
        hip_room_rear: {
            name: 'Hip Room (rear)', unit: 'in.'
        },
        shoulder_room_front: {
            name: 'Shoulder Room (front)', unit: 'in.'
        },
        shoulder_room_rear: {
            name: 'Shoulder Room (rear)', unit: 'in.'
        },
        leg_room_front: {
            name: 'Leg Room (front)', unit: 'in.'
        },
        leg_room_rear: {
            name: 'Leg Room (rear)', unit: 'in.'
        },
        head_room_third_row: {
            name: 'Head Room (3rd row)', unit: 'in.'
        },
        shoulder_room_third_row: {
            name: 'Shoulder Room (3rd row)', unit: 'in.'
        },
        leg_room_third_row: {
            name: 'Leg Room (3rd row)', unit: 'in.'
        }
    },
    Measurements: {
        length: {
            name: 'Length', unit: 'in.'
        },
        length_no_bumpers: {
            name: 'Length (no bumpers)', unit: 'in.'
        },
        width: {
            name: 'Width', unit: 'in.'
        },
        width_no_mirros: {
            name: 'Width (no mirrors)', unit: 'in.'
        },
        height: {
            name: 'Height', unit: 'in.'
        },
        bed_length: {
            name: 'Bed Length', unit: 'in.'
        },
        bed_code: {
            name: 'Bed Code'
        },
        ground_clearance: {
            name: 'Ground Clearance', unit: 'in.'
        },
        wheelbase: {
            name: 'Wheelbase', unit: 'in.'
        },
        front_track: {
            name: 'Front Track', unit: 'in.'
        },
        rear_track: {
            name: 'Rear Track', unit: 'in.'
        },
    },
    'Interior Dimensions': {
        interior_volume: {
            name: 'Interior Volume', unit: 'cuft'
        },
        passenger_volume: {
            name: 'Passenger Volume', unit: 'cuft'
        },
        passenger_volume_third_row: {
            name: 'Passenger Volume (3rd row)', unit: 'cuft'
        },
        cargo_volume: {
            name: 'Cargo Volume', unit: 'cuft'
        },
        cargo_volume_rear_seats_down: {
            name: 'Cargo Volume (rear seats down)', unit: 'cuft'
        },
        cargo_volume_row3_down: {
            name: 'Cargo Volume (3rd row down)', unit: 'cuft'
        }
    },
    Weight: {
        curb_weight: {
            name: 'Curb Weight', unit: 'lbs'
        },
        gross_vehicle_weight_rating: {
            name: 'Gross Weight', unit: 'lbs'
        },
        gross_combined_weight_rating: {
            name: 'Gross Combined Weight', unit: 'lbs'
        }
    },
    'Wheels & Tires': {
        wheel_dia: {
            name: 'Wheel Diameter', unit: 'in.'
        },
        rear_wheel_dia: {
            name: 'Wheel Diameter (rear)', unit: 'in.'
        },
        tire_type: {
            name: 'Tire'
        },
        rear_tire_type: {
            name: 'Tire (rear)'
        }
    },
    Performance: {
        acceleration: {
            name: 'Acceleration (0-60 mph)', unit: 'seconds'
        },
        acceleration_100: {
            name: 'Acceleration (0-100 mph)', unit: 'seconds'
        },
        braking_distance: {
            name: 'Breaking Distance', unit: 'ft.'
        },
        angle_of_approach: {
            name: 'Angle of Approach', unit: 'degree'
        },
        angle_of_departure: {
            name: 'Angle of Departure', unit: 'degree'
        },
        aerodynamic_drag: {
            name: 'Aerodynamic Drag', unit: 'drag'
        },
        turning_circle: {
            name: 'Turning Circle', unit: 'ft.'
        },
        breakover_angle: {
            name: 'Breakover Angle', unit: 'degree'
        },
        max_payload: {
            name: 'Max Payload', unit: 'lbs'
        },
        towing_capacity: {
            name: 'Towing Capacity', unit: 'lbs'
        },
        max_towing_capacity: {
            name: 'Max Towing Capacity', unit: 'lbs'
        }
    },
    'Fuel Tank': {
        tank1_gal: {
            name: 'Fuel Tank Volume', unit: 'gallon'
        },
        tank2_gal: {
            name: 'Fuel Tank (2) Volume', unit: 'gallon'
        }
    }
};
